type TokenGetter = () => Promise<string | undefined>;

let getter: TokenGetter = async () => undefined;

export function registerTokenGetter(fn: TokenGetter): void {
  getter = fn;
}

export function getAccessToken(): Promise<string | undefined> {
  return getter();
}
